import React from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import { missingField } from 'app/constants';

export const QuantityComponent = React.memo(function QuantityComponent(cellParams: any) {
  const value = cellParams?.row?.quantity;
  return (
    <div>
      <span>{value === missingField || value === null || value === '' ? missingField : `${value}`}</span>
    </div>
  );
});

export const Quantity = (params: GridCellParams) => {
  return <QuantityComponent {...params} />;
};
